import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MemberService } from '../shared/services/member.service';
import Swal from 'sweetalert2';
import { WhiteSpaceValidator } from '../shared/validators/white-space-validator';
import { param } from 'jquery';
import { MatPaginator } from '@angular/material/paginator';
declare var $: any;
@Component({
  selector: 'app-adminsetting',
  templateUrl: './adminsetting.component.html',
  styleUrls: ['./adminsetting.component.css']
})
export class AdminsettingComponent implements OnInit {
  token: string;
  supportList:any[]=[];
  selectedAssigner: number = 0;
  disabled: any;
  selectedCategoryId:any=0;
  catagoryDropDown: any;
  filterList: any[];
  selectedAssigners: any[];
   constructor(private spinnerService: NgxSpinnerService, private memberService: MemberService, private formBuilder: FormBuilder, private router: Router) {
      this.spinnerService.show();
    }
  ngOnInit(): void {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  this.token = "Bearer" + " " + user.jwtToken;
  // this.organizationName = user.organaisationName;
  // this.orgId=user.organaisationId;
  this.getSupportList();
  this.getCatogoryList();

  }
  CategoryFilter(){
    console.log()
    this.filterList=this.supportList.filter(
      value =>
        value.parentCategoryId == this.selectedCategoryId 
    );
    this.disabled = this.filterList
    .filter(value => value.typeOfMember === "Assigner" && value.isActive === true)
    
       
    this.selectedAssigners=this.disabled.map(value=>value.supportId);
    // this.selectedAssigners=this.disabled;
    console.log('SupportList',this.selectedAssigners);
    

  }
  getCatogoryList(){
    this.spinnerService.show();
    this.memberService
    .getCatogoryList( this.token)
    .subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.catagoryDropDown=data.categoryLists;
          this.catagoryDropDown=this.catagoryDropDown.map(value=>({
            categoryName:value.categoryName,
            categoryId:parseInt(value.categoryId),
          })
          );
         
        
        

          // this.groupList= data.vendorGroupList.map(group => ({
          //   id: group.groupId,
          //   name: group.name,
          // }));
         console.log('data -------> ',this.catagoryDropDown);
          return;
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );
  }

  submit() {
    this.spinnerService.show();
    console.log('Submit',this.selectedAssigner);
    // Your submit logic here
    let params={
      "technicianId":this.selectedAssigner,
      "categoryId": this.selectedCategoryId
    }
// PostAdminAddSupportAssigner(params:any,token: string) 

    this.memberService.PostAdminAddSupportAssigner(params,this.token) .subscribe(
      (data: any) => {
        this.spinnerService.hide();
        // this.ishubspotLoading = false;
        if (data.statusCode == 200) {
          Swal.fire({
            title: data.statusMessage,
            icon: "success",
            showCloseButton: true,
            allowOutsideClick: false
          }).then(() => {
            this.selectedAssigner = 0;
            this.ngOnInit(); // Re-initialize component state
          });
         
          
        }
        else {
          this.spinnerService.hide();
         
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();

        }
      },
      err => {
        if (err.status === 401) {
          this.spinnerService.hide();
          this.unauthorizedException();
        }
      }
    );

  }
  getSupportList(){
    // let sampleData = [
    //   {
    //     "firstName": "John",
    //     "lastName": "Doe",
    //     "email": "john.doe@example.com",
    //     "designation": "Software Engineer",
    //     "supportId": 1,
    //     "isActive": 1,
    //     "isDeleted": 0
    //   },
    //   {
    //     "firstName": "Jane",
    //     "lastName": "Smith",
    //     "email": "jane.smith@example.com",
    //     "designation": "Project Manager",
    //     "supportId": 2,
    //     "isActive": 1,
    //     "isDeleted": 0
    //   },
    //   {
    //     "firstName": "Robert",
    //     "lastName": "Brown",
    //     "email": "robert.brown@example.com",
    //     "designation": "UX Designer",
    //     "supportId": 3,
    //     "isActive": 0,
    //     "isDeleted": 0
    //   },
    //   {
    //     "firstName": "Emily",
    //     "lastName": "Davis",
    //     "email": "emily.davis@example.com",
    //     "designation": "Quality Analyst",
    //     "supportId": 4,
    //     "isActive": 1,
    //     "isDeleted": 1
    //   },
    //   {
    //     "firstName": "Michael",
    //     "lastName": "Wilson",
    //     "email": "michael.wilson@example.com",
    //     "designation": "DevOps Engineer",
    //     "supportId": 5,
    //     "isActive": 0,
    //     "isDeleted": 1
    //   },
    //   {
    //     "firstName": "Sarah",
    //     "lastName": "Taylor",
    //     "email": "sarah.taylor@example.com",
    //     "designation": "Business Analyst",
    //     "supportId": 6,
    //     "isActive": 1,
    //     "isDeleted": 0
    //   }
    // ];
    
    // this.supportList=sampleData;
    // this.dataSource = new MatTableDataSource(sampleData);
    
      //  this.dataSourceAnnouncement= new MatTableDataSource(sampleData);
       
        // this.spinnerService.show();
        // let params={
        //   "roleId": 0,
        //   "pageNo": 1,
        //   "pageSize": 5
        // }
       
        // return;
        this.memberService.SupportHelpdeskList(this.token).subscribe(
          (data: any) => {
            // this.ishubspotLoading = false;
            if (data.statusCode == 200) {
              this.supportList = data.supportList;
              
             
              console.log(this.selectedAssigners);
              console.log('SupportList',this.supportList);
              // let map=data.supportList.filter(value=>value.typeOfMember=="Assigner" && value.isActive === true);
              // console.log('map',map);
              //   if(map.length==0){
              //     this.selectedAssigner=0;
              //   }
              //   else{
              //     this.selectedAssigner=map[0].supportId;
              //   }
              this.spinnerService.hide();
              // console.log(data.statusCode)
              // setTimeout(() => {
              //   this.spinnerService.hide();
              // }, 800)
              // let userData = this.getMemberListArray(data.memberList);
              // this.users = data.announcementList;
              // console.log('Users', this.users);
              // this.users=data.supportList
              // this.dataSource = new MatTableDataSource(this.users);
              // this.dataSource.paginator = this.paginator;
              // this.totalItems = data.filteredCount
              // this.dataSource.sort = this.sort;
              // this.spinnerService.hide();
            }
            else {
             
              Swal.fire({
                title: data.statusMessage,
                icon: "warning",
                showCloseButton: true,
                allowOutsideClick: false
              });
              this.spinnerService.hide();
    
            }
          },
          err => {
            if (err.status === 401) {
              this.spinnerService.hide();
              this.unauthorizedException();
            }
          }
        );
  
  }
  unauthorizedException() {
        Swal.fire({
          icon: "warning",
          title: "Session Expired!",
          allowOutsideClick: false,
          confirmButtonColor: "#d33",
          confirmButtonText: "Logout"
        }).then(() => {
          localStorage.clear();
          this.router.navigate(["/login"]);
        });
        return;
      }
  

}
